import Connection from '../signalr/connection';
const loadSubscriptionsType = 'LOAD_SUBSCRIPTIONS';
const saveSubscriptionsType = 'SAVE_SUBSCRIPTIONS';


const initialState = {
    ossIdSubs: {},
};

export const actionCreators = {
    loadSubscriptions: () => async (dispatch, getState) => {
        dispatch({ type: loadSubscriptionsType });
    },
    removeOssIdSubscriptions: (list) => async (dispatch, getState) => {
        let subs = { ...(getState().subscriptions.ossIdSubs) };
        for (let index = 0; index != list.length; ++index) {
            let { ossId, category } = list[index];

            if (!['historical'].includes(category)) throw new Error(`is this category intentional? ${category}`);
            if (!ossId) throw new Error(`ossId should be a positive integer... ${ossId}`);

            if (subs[ossId] && subs[ossId][category]) {
                Connection.then(c => c.invoke("Unsubscribe", category, { ossIds: [ossId] }).then(() => {
                    console.log(`unsubscribed from ${ossId}`)
                    delete subs[ossId][category];
                    subs[ossId][category] = false;

                    dispatch({ type: saveSubscriptionsType, ossIdSubs: subs });
                }).catch(() => {
                    
                }));
                
            }
        }

        
    },
    addOssIdSubscriptions: (list) => async (dispatch, getState) => {
        let subs = { ...(getState().subscriptions.ossIdSubs) };
        let newSubsToAdd = [];
        for (let index = 0; index != list.length; ++index) {
            let { ossId, category } = list[index];

            if (!['historical'].includes(category)) throw new Error(`is this category intentional? ${category}`);
            if (!ossId) throw new Error(`ossId should be a positive integer... ${ossId}`);

            if (subs[ossId]) {
                if (!subs[ossId][category]) {
                    newSubsToAdd.push(ossId);
                    subs[ossId][category] = true;
                }
            }
            else {
                subs[ossId] = { [category]: true };
                newSubsToAdd.push(ossId);
            }
        }

        Connection.then(c => c.invoke("Subscribe", 'historical', { ossIds: newSubsToAdd })).then(() => {
            console.log(`subscribed to ${newSubsToAdd}`)
            dispatch({ type: saveSubscriptionsType, ossIdSubs: subs });
        }).catch (() => {
        
        });

        
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === loadSubscriptionsType) {
        return {
            ...state,
            ossIdSubs: JSON.parse(localStorage.getItem('ossIdSubs')) || initialState.ossIdSubs
        };
    }

    if (action.type === saveSubscriptionsType) {
        localStorage.setItem('ossIdSubs', JSON.stringify(action.ossIdSubs));
        return {
            ...state,
            ossIdSubs: JSON.parse(JSON.stringify(action.ossIdSubs))
        };
    }

    return state;
};